import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { catchError, combineLatest, from, map, of, switchMap } from 'rxjs'

import { dispensaryBySlugQuery } from '../../groq/sanity-dispensaries/dispensary'
import { isLeft, right } from '../../utils/result'
import { coerceCaughtToLeft } from '../../utils/rx/errors'
import { UseUserDispensary } from '../dispensaries/hooks/useUserDispensary'
import { dispensariesClientCdn, fetchQuery } from './client'

const [patientDispensaryFetchMethod$, setPatientDispensaryFetchMethod] =
  createSignal<UseUserDispensary['getUserDispensary']>()

export { setPatientDispensaryFetchMethod }

const patientSanityDispensary$ = patientDispensaryFetchMethod$.pipe(
  switchMap((getPatientDispensary) => from(getPatientDispensary())),
  map((dispensary) => right(dispensary ?? null)),
  catchError(coerceCaughtToLeft),
  switchMap((result) =>
    isLeft(result) || !result.data
      ? combineLatest([of(result), of(right(null))])
      : combineLatest([
          of(right(result.data)),
          fetchQuery(dispensaryBySlugQuery, { slug: result.data.slug })(dispensariesClientCdn).pipe(
            catchError(coerceCaughtToLeft),
          ),
        ]),
  ),
)

export const [usePatientSanityDispensary, latestPatientSanityDispensary$] =
  bind(patientSanityDispensary$)
